import React, { useEffect } from "react";
import { connect } from "react-redux";

import { LoadingSpinner } from "@mapmycustomers/ui";

import { createIntegration } from "@app/store/integrations/actions";

interface Props {
  createIntegration: typeof createIntegration.request;
}

const AddIntegration: React.FC<Props> = ({ createIntegration }) => {
  const params = new Map(new URLSearchParams(window.location.search).entries());

  useEffect(
    () => {
      if (params.size > 0) {
        createIntegration(params);
      }
    },
    // only update when size changes, not the params itself
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [createIntegration, params.size]
  );

  return <LoadingSpinner global />;
};

const mapDispatchToProps = {
  createIntegration: createIntegration.request,
};

export default connect(null, mapDispatchToProps)(AddIntegration);
